import {gql} from '@apollo/client';

export const GET_SHIPPING_PRICE = gql`
    query shippingPrice($input: ShippingInput!){
        shippingPrice(input: $input){
            totalCost
            serviceType
            deliveryMessage
        }
    }
`